import { createFileRoute } from "@tanstack/react-router";

import { env } from "@/env/public-env";
import { StructuredData } from "@/shared/components/structured-data";
import { ContactForm } from "@/shared/contact-form";
import {
  seo,
  getCanonicalLinks,
  createPageTitle,
} from "@/utils/seo";
import { WebLayout } from "@/web/layout/web-layout";
export const Route = createFileRoute("/_web/contact")({
  head: () => ({
    meta: [
      ...seo({
        title: createPageTitle("Contact Us"),
        description:
          "Get in touch with the vivus team. Contact us for support, partnership opportunities, or to learn more about our AI integration platform.",
        keywords: "vivus",
        canonical: "https://vivus.cz/contact",
        image: `${env.VITE_BASE_URL}/api/og/page/contact.png`,
      }),
    ],
    links: [
      ...getCanonicalLinks(`${env.VITE_BASE_URL}/contact`),
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <WebLayout>
      <StructuredData
        url="https://vivus.cz/contact"
        description="Get in touch with the vivus team. Contact us for support, partnership opportunities, or to learn more about our AI integration platform."
        about="Contact Information"
        titleParts={["Contact Us"]}
      />
      <ContactForm />
    </WebLayout>
  );
}
